export default function animateNumbers(element, data) {
    const numbers = document.querySelectorAll(".number");

    numbers.forEach((numberElem, index) => {
        const endValue = parseInt(numberElem.getAttribute("data-value"), 10); // Конечное значение из data-value
        const duration = 500; // Длительность анимации в миллисекундах
        const stepTime = Math.abs(Math.floor(duration / endValue)); // Время между каждым увеличением
        const delay = index * 500; // Задержка на 500 мс для каждого следующего элемента

        let currentValue = 0;

        // Функция для обновления значения
        const updateNumber = () => {
            numberElem.textContent = currentValue; // Обновляем текстовое содержимое
            if (currentValue < endValue) {
                currentValue++;
                setTimeout(updateNumber, stepTime);
            }
        };

        // Запуск анимации с задержкой
        setTimeout(updateNumber, delay);
    });
};